import { FormBuilder, FormControl, Validators, FormArray, FormGroup} from "@angular/forms";
import { AdminFormGroup, IUserLicenseEditor } from "@myapp/features/admin/models";
import { Module, ModuleChecked } from '../../../models';
export class LicenseUserEditForm extends AdminFormGroup {
  firstName = this.get('firstName') as FormControl;
  lastName = this.get('lastName') as FormControl;
  email = this.get('email') as FormControl;
  modules = this.get('modules') as FormArray;

  public modulesLst?: ModuleChecked[] | any = [];
  public checkedModuleIds?: string[] | any;

  constructor(readonly user: IUserLicenseEditor, readonly fb: FormBuilder = new FormBuilder()) {
    super(fb.group({
      firstName: [user?.firstName, Validators.required],
      lastName: [user?.lastName, Validators.required],
      email: [user?.email],
      modules: [user?.modules]
    }).controls);
    this.modulesLst = user?.modules;
  }


  getItem(): IUserLicenseEditor {

    var user = {
      firstName: this.firstName.value,
      lastName: this.lastName.value,
      email: this.email.value,
      modules: this.modules.value,
      checkedIds: this.checkedModuleIds
    };

    return user;
  }

 
}
